/**
 * Novelarc 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

/**
 * Novelarc 品牌特定主题配置
 * 注意: 大部分颜色应使用 UnoCSS 主题变量,这里只保留品牌特有的配置
 */
export const theme = {
  // 引用装饰线颜色 (Novelarc 使用橙色调,基于主色 #FF771C)
  quoteColor: 'rgba(255, 119, 28, 0.3)',
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
